import {
    FormControl,
    InputLabel,
    Select,
    TextField,
    MenuItem,
    Button,
    Dialog,
    DialogContent,
    Chip,
    IconButton,
    Menu,
    DialogTitle,
    DialogContentText,
    DialogActions,
    Box,
    Typography,
    Tooltip,
} from '@mui/material';
import { t } from 'i18next';
import React, { FC, useEffect, useState } from 'react';
import { CommentCommand } from '../../../services/command';
import ZoomInRoundedIcon from '@mui/icons-material/ZoomInRounded';
import '../CustomerCommentApprovalPage.scss';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import AssignmentIndRoundedIcon from '@mui/icons-material/AssignmentIndRounded';
import AccessTimeRoundedIcon from '@mui/icons-material/AccessTimeRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import Swal from 'sweetalert2';
import { SCUILoading, SCUIPagination } from '../../../atomic/atoms';
import { NoResultFoundComponent } from '../../CustomerManagement/components/NoResultFoundComponent/NoResultFoundComponent';
import TimeHelper from '../../../utils/time';
import { CCAPP, ccappCls } from '../customerCommentApproval.classes';

const COL = {
    image: { width: 80, flexShrink: 0 },
    id: { width: 140, flexShrink: 0 },
    brand: { width: 160, flexShrink: 0 },
    summary: { flex: 1, minWidth: 0, marginRight: 5 },
    operator: { width: 150, flexShrink: 0 },
    status: { width: 140, flexShrink: 0 },
    assign: { width: 100, flexShrink: 0 },
    actions: { width: 36, flexShrink: 0 },
} as const;

interface IProps {
    datas?: any;
    recordCount?: any;
    GetReviewSummaries?: any;
    handleChangeRows?: any;
    page?: any;
    rowsPerPage?: any;
    setPage?: any;
    rejectList?: any;
    loading?: any;
}
export const CommentApprovalTableComponent: FC<IProps> = ({
    datas,
    recordCount,
    GetReviewSummaries,
    handleChangeRows,
    page,
    rowsPerPage,
    setPage,
    rejectList,
    loading,
}) => {
    const [selectedReview, setSelectedReview] = React.useState<any>();
    const [openModal, setOpenModal] = useState(false);
    const [selectedImage, setSelectedImage] = useState('');
    const [open, setOpen] = React.useState(false);
    const [openRowPopUp, setOpenRowPopUp] = React.useState(false);
    const [cancelReason, setCancelReason] = React.useState(
        selectedReview?.review?.cancellationReason !== null ? selectedReview?.review?.cancellationReason : ''
    );
    const [text, setText] = React.useState('');

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleClickOpenRowPopUp = (text?: any) => {
        setText(text);
        setOpenRowPopUp(true);
    };

    const handleCloseRowPopUp = () => {
        setOpenRowPopUp(false);
    };
    const handleOpenModal = (imageUrl: any) => {
        setSelectedImage(imageUrl);
        setOpenModal(true);
    };
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    useEffect(() => {
        if (selectedReview) {
            setCancelReason(selectedReview.review.cancellationReason);
        }
    }, [selectedReview]);
    const PostAssigToMe = (optionId: any) => {
        let params: any = {};
        params.optionId = optionId;
        CommentCommand.AssignOperatorReviewSummary(params)
            .then((res: any) => {
                if (res && res.length > 15) {
                    Swal.fire(res, ' ', 'error');
                } else {
                    Swal.fire(t('general.updated'), ' ', 'success');
                }
                GetReviewSummaries();
            })
            .finally(() => {});
    };
    const UpdateReview = (optionId: any, summary: any, status: any, cancellationReason: any) => {
        let params: any = {};
        params.optionId = optionId;
        params.summary = summary;
        params.status = status;
        params.cancellationReason = cancellationReason;
        CommentCommand.UpdateReviewsSummary(params)
            .then((res: any) => {
                if (res && res.Key.length > 1) {
                    Swal.fire('Bu ürün başka bir operatöre atandı veya atama işlemi yapılmadı.', ' ', 'error');
                } else {
                    Swal.fire(t('general.updated'), ' ', 'success');
                }
                GetReviewSummaries();
            })
            .finally(() => {});
    };
    const statusConfig = (isApproved: number) => {
        if (isApproved === 2)
            return {
                label: t('general.approved'),
                color: '#16a34a',
                bg: 'rgba(22,163,74,0.1)',
                border: 'rgba(22,163,74,0.25)',
            };
        if (isApproved === 4)
            return {
                label: t('general.declined'),
                color: '#dc2626',
                bg: 'rgba(220,38,38,0.1)',
                border: 'rgba(220,38,38,0.25)',
            };
        return {
            label: t('general.waitingForApproval'),
            color: '#2563eb',
            bg: 'rgba(37,99,235,0.1)',
            border: 'rgba(37,99,235,0.25)',
        };
    };

    function Row(review: any) {
        const status = statusConfig(review?.review?.isApproved);
        return (
            <Box
                className={CCAPP.tableRow}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    mb: 1.5,
                    p: { xs: 1.5, md: 2 },
                    borderRadius: '20px',
                    border: '1px solid rgba(148,163,184,0.14)',
                    background: 'linear-gradient(135deg, #ffffff 0%, rgba(248,250,255,0.9) 100%)',
                    boxShadow: '0 2px 12px rgba(15,23,42,0.06)',
                    transition: 'all 0.22s ease',
                    cursor: 'default',
                    '&:hover': {
                        boxShadow: '0 8px 28px rgba(15,23,42,0.12)',
                        transform: 'translateY(-2px)',
                        border: '1px solid rgba(148,163,184,0.28)',
                    },
                }}
            >
                {/* Image */}
                <Box
                    sx={{
                        position: 'relative',
                        ...COL.image,
                        height: 80,
                        borderRadius: '16px',
                        overflow: 'hidden',
                        border: '1px solid rgba(148,163,184,0.2)',
                        boxShadow: '0 2px 8px rgba(15,23,42,0.1)',
                    }}
                >
                    <img
                        src={review?.review?.medias?.[0]}
                        alt=""
                        style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
                    />
                    <Box
                        className={CCAPP.rowImageZoom}
                        onClick={() => handleOpenModal(review?.review?.medias?.[0])}
                        sx={{
                            position: 'absolute',
                            top: 4,
                            right: 4,
                            bgcolor: 'rgba(255,255,255,0.9)',
                            borderRadius: '8px',
                            width: 24,
                            height: 24,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            boxShadow: '0 1px 4px rgba(0,0,0,0.15)',
                            transition: 'all 0.18s ease',
                            '&:hover': { bgcolor: '#fff', transform: 'scale(1.1)' },
                        }}
                    >
                        <ZoomInRoundedIcon sx={{ fontSize: 16, color: '#2563eb' }} />
                    </Box>
                </Box>

                {/* ID + Date */}
                <Box sx={COL.id}>
                    <Tooltip title="Ürün sayfasını aç">
                        <Box
                            onClick={() =>
                                window.open(
                                    'https://www.lcw.com/model/?modelId=' +
                                        review.review.modelCode +
                                        '&optionId=' +
                                        review.review.optionId,
                                    '_blank',
                                    'noopener,noreferrer'
                                )
                            }
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 0.5,
                                cursor: 'pointer',
                                '&:hover .id-text': { textDecoration: 'underline' },
                            }}
                        >
                            <Typography
                                className="id-text"
                                sx={{
                                    fontSize: 13,
                                    fontWeight: 700,
                                    color: '#2563eb',
                                    letterSpacing: '-0.01em',
                                }}
                            >
                                {review.review.id.replace(/^option::/, '')}
                            </Typography>
                            <OpenInNewRoundedIcon sx={{ fontSize: 13, color: '#2563eb', opacity: 0.7 }} />
                        </Box>
                    </Tooltip>
                    {review.review.approvalDate && (
                        <Tooltip title="Son Güncellenme Tarihi">
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mt: 0.5 }}>
                                <AccessTimeRoundedIcon sx={{ fontSize: 12, color: '#94a3b8' }} />
                                <Typography sx={{ fontSize: 11, color: '#94a3b8' }}>
                                    {TimeHelper.formatDateHour(review.review.approvalDate)}
                                </Typography>
                            </Box>
                        </Tooltip>
                    )}
                </Box>

                {/* Brand + Codes */}
                <Box sx={COL.brand}>
                    <Typography sx={{ fontSize: 13, fontWeight: 700, color: '#0f172a', mb: 0.5 }}>
                        {review.review.brand?.name}
                    </Typography>
                    <Chip
                        label={review.review.specialCode + ' - ' + review.review.colorCode}
                        size="small"
                        sx={{
                            fontSize: 11,
                            fontWeight: 600,
                            height: 22,
                            bgcolor: 'rgba(124,58,237,0.08)',
                            color: '#7c3aed',
                            border: '1px solid rgba(124,58,237,0.18)',
                            borderRadius: '8px',
                        }}
                    />
                </Box>

                {/* Summary */}
                <Box sx={COL.summary}>
                    <Tooltip title={review.review.summary}>
                        <Typography
                            sx={{
                                fontSize: 13,
                                color: '#334155',
                                lineHeight: 1.55,
                                overflow: 'hidden',
                                display: '-webkit-box',
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: 'vertical',
                                cursor: 'default',
                            }}
                        >
                            {review.review.summary}
                        </Typography>
                    </Tooltip>
                </Box>

                {/* Operator */}
                <Box sx={{ ...COL.operator, overflow: 'hidden' }}>
                    <Typography
                        sx={{
                            fontSize: 12,
                            color: '#475569',
                            fontWeight: 500,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {review.review.operatorName || '-'}
                    </Typography>
                </Box>

                {/* Status Chip */}
                <Box sx={COL.status}>
                    <Chip
                        label={status.label}
                        size="small"
                        sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            px: 1,
                            height: 28,
                            bgcolor: status.bg,
                            color: status.color,
                            border: `1px solid ${status.border}`,
                            borderRadius: '10px',
                        }}
                    />
                </Box>

                {/* Assign To Me */}
                <Box sx={COL.assign}>
                    <Chip
                        label={t('general.assignToMe') as string}
                        icon={<AssignmentIndRoundedIcon sx={{ fontSize: '14px !important' }} />}
                        onClick={() => PostAssigToMe(review.review.optionId)}
                        size="small"
                        className={CCAPP.fieldAssignToMe}
                        sx={{
                            fontSize: 12,
                            fontWeight: 700,
                            height: 30,
                            cursor: 'pointer',
                            bgcolor: 'rgba(37,99,235,0.08)',
                            color: '#2563eb',
                            border: '1px solid rgba(37,99,235,0.22)',
                            borderRadius: '10px',
                            transition: 'all 0.18s ease',
                            '&:hover': {
                                bgcolor: 'rgba(37,99,235,0.16)',
                                boxShadow: '0 2px 10px rgba(37,99,235,0.2)',
                            },
                        }}
                    />
                </Box>

                {/* Actions Menu */}
                <Box sx={COL.actions}>
                    <PopupState variant="popover" popupId="demo-popup-menu">
                        {(popupState: any) => (
                            <React.Fragment>
                                <Tooltip title="İşlemler">
                                    <IconButton
                                        {...bindTrigger(popupState)}
                                        size="small"
                                        className={ccappCls(CCAPP.input, CCAPP.inputIconButton, CCAPP.rowActionsTrigger)}
                                        sx={{
                                            border: '1px solid rgba(148,163,184,0.25)',
                                            bgcolor: 'rgba(148,163,184,0.06)',
                                            transition: 'all 0.18s ease',
                                            '&:hover': {
                                                bgcolor: 'rgba(148,163,184,0.14)',
                                                transform: 'scale(1.08)',
                                            },
                                        }}
                                    >
                                        <MoreVertRoundedIcon sx={{ fontSize: 18 }} />
                                    </IconButton>
                                </Tooltip>
                                <Menu
                                    {...bindMenu(popupState)}
                                    slotProps={{
                                        paper: {
                                            sx: {
                                                borderRadius: '16px',
                                                boxShadow: '0 8px 32px rgba(15,23,42,0.14)',
                                                border: '1px solid rgba(148,163,184,0.14)',
                                                minWidth: 160,
                                                mt: 0.5,
                                            },
                                        },
                                    }}
                                >
                                    <MenuItem
                                        className={ccappCls(CCAPP.input, CCAPP.inputMenuItem, CCAPP.rowActionEdit)}
                                        sx={{
                                            fontSize: 13,
                                            fontWeight: 500,
                                            gap: 1,
                                            borderRadius: '10px',
                                            mx: 0.5,
                                            '&:hover': { bgcolor: 'rgba(15,23,42,0.05)' },
                                        }}
                                        onClick={() => {
                                            handleClickOpenRowPopUp(review.review.summary);
                                            setSelectedReview(review);
                                        }}
                                    >
                                        <EditRoundedIcon sx={{ fontSize: 16, color: '#475569' }} />
                                        {t('general.edit') as string}
                                    </MenuItem>
                                    <MenuItem
                                        className={ccappCls(CCAPP.input, CCAPP.inputMenuItem, CCAPP.rowActionAccept)}
                                        sx={{
                                            fontSize: 13,
                                            fontWeight: 500,
                                            gap: 1,
                                            color: '#16a34a',
                                            borderRadius: '10px',
                                            mx: 0.5,
                                            '&:hover': { bgcolor: 'rgba(22,163,74,0.08)' },
                                        }}
                                        onClick={() =>
                                            UpdateReview(review.review.optionId, review.review.summary, 2, null)
                                        }
                                    >
                                        <CheckCircleRoundedIcon sx={{ fontSize: 16 }} />
                                        {t('general.accept') as string}
                                    </MenuItem>
                                    <MenuItem
                                        className={ccappCls(CCAPP.input, CCAPP.inputMenuItem, CCAPP.rowActionDecline)}
                                        sx={{
                                            fontSize: 13,
                                            fontWeight: 500,
                                            gap: 1,
                                            color: '#dc2626',
                                            borderRadius: '10px',
                                            mx: 0.5,
                                            '&:hover': { bgcolor: 'rgba(220,38,38,0.08)' },
                                        }}
                                        onClick={() => {
                                            handleClickOpen();
                                            setSelectedReview(review);
                                        }}
                                    >
                                        <CancelRoundedIcon sx={{ fontSize: 16 }} />
                                        {t('general.decline') as string}
                                    </MenuItem>
                                </Menu>
                            </React.Fragment>
                        )}
                    </PopupState>
                </Box>
            </Box>
        );
    }

    return (
        <Box className={CCAPP.tableRoot}>
            {/* Image Zoom Modal */}
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                className={CCAPP.dialogImageZoom}
                slotProps={{
                    paper: {
                        sx: { borderRadius: '20px', overflow: 'hidden' },
                    },
                }}
            >
                <DialogContent sx={{ p: 0 }}>
                    <img src={selectedImage} style={{ width: '420px', height: 'auto', display: 'block' }} alt="" />
                </DialogContent>
            </Dialog>

            {/* Table Column Headers */}
            <Box
                className={CCAPP.tableHeaderRow}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    mb: 1,
                    px: 2,
                    py: 1,
                }}
            >
                <Box sx={COL.image} />
                <Typography
                    sx={{
                        ...COL.id,
                        fontSize: 11,
                        fontWeight: 700,
                        color: '#94a3b8',
                        textTransform: 'uppercase',
                        letterSpacing: '0.06em',
                    }}
                >
                    ID
                </Typography>
                <Typography
                    sx={{
                        ...COL.brand,
                        fontSize: 11,
                        fontWeight: 700,
                        color: '#94a3b8',
                        textTransform: 'uppercase',
                        letterSpacing: '0.06em',
                    }}
                >
                    {t('customerComment.brandSpecialColor') as string}
                </Typography>
                <Typography
                    sx={{
                        ...COL.summary,
                        fontSize: 11,
                        fontWeight: 700,
                        color: '#94a3b8',
                        textTransform: 'uppercase',
                        letterSpacing: '0.06em',
                    }}
                >
                    {t('customerComment.commentSummary') as string}
                </Typography>
                <Typography
                    sx={{
                        ...COL.operator,
                        fontSize: 11,
                        fontWeight: 700,
                        color: '#94a3b8',
                        textTransform: 'uppercase',
                        letterSpacing: '0.06em',
                    }}
                >
                    {t('customerComment.person') as string}
                </Typography>
                <Typography
                    sx={{
                        ...COL.status,
                        fontSize: 11,
                        fontWeight: 700,
                        color: '#94a3b8',
                        textTransform: 'uppercase',
                        letterSpacing: '0.06em',
                    }}
                >
                    {t('customerInformation.status') as string}
                </Typography>
                <Box sx={COL.assign} />
                <Box sx={COL.actions} />
            </Box>

            {/* Decline Reason Dialog */}
            <Dialog
                open={open}
                onClose={handleClose}
                className={CCAPP.dialogDecline}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: '24px',
                            boxShadow: '0 24px 64px rgba(15,23,42,0.16)',
                            border: '1px solid rgba(148,163,184,0.14)',
                        },
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 700, pb: 1 }}>
                    Reddetme Nedenini Seçiniz
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Box sx={{ width: '400px', pt: 1, display: 'flex', alignItems: 'center' }}>
                            <FormControl fullWidth className={CCAPP.fieldDeclineReason}>
                                <InputLabel id="demo-simple-select-label">
                                    {t('customerComment.cancelReason') as string}
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={cancelReason}
                                    label={t('customerComment.cancelReason') as string}
                                    onChange={(event: any) => {
                                        setCancelReason(event.target.value);
                                    }}
                                    sx={{ borderRadius: '14px' }}
                                    className={ccappCls(CCAPP.input, CCAPP.inputSelect, CCAPP.fieldDeclineReason)}
                                >
                                    {rejectList &&
                                        rejectList.map((item: any) => (
                                            <MenuItem key={item.id} id={item.id} value={item.id}>
                                                {item.reasonRejection}
                                            </MenuItem>
                                        ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        onClick={handleClose}
                        variant="outlined"
                        className={ccappCls(CCAPP.input, CCAPP.inputButton, CCAPP.btnDeclineCancel)}
                        sx={{ borderRadius: '12px', textTransform: 'none', fontWeight: 600 }}
                    >
                        {t('general.cancel') as string}
                    </Button>
                    <Button
                        onClick={() => {
                            handleClose();
                            UpdateReview(
                                selectedReview.review.optionId,
                                selectedReview.review.summary,
                                4,
                                cancelReason
                            );
                        }}
                        autoFocus
                        variant="contained"
                        color="error"
                        className={ccappCls(CCAPP.input, CCAPP.inputButton, CCAPP.btnDeclineConfirm)}
                        sx={{ borderRadius: '12px', textTransform: 'none', fontWeight: 600 }}
                    >
                        {t('general.complete') as string}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Edit Summary Dialog */}
            <Dialog
                open={openRowPopUp}
                onClose={handleCloseRowPopUp}
                className={CCAPP.dialogEditSummary}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                slotProps={{
                    paper: {
                        sx: {
                            borderRadius: '24px',
                            boxShadow: '0 24px 64px rgba(15,23,42,0.16)',
                            border: '1px solid rgba(148,163,184,0.14)',
                        },
                    },
                }}
            >
                <DialogTitle id="alert-dialog-title" sx={{ fontWeight: 700, pb: 1 }}>
                    {t('general.edit') as string}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        <Box sx={{ width: '440px', pt: 1 }}>
                            <TextField
                                variant="outlined"
                                fullWidth
                                multiline
                                rows={6}
                                placeholder={t('customerComment.commentSummary')}
                                value={text}
                                onChange={(event: any) => {
                                    setText(event.target.value);
                                }}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '14px' } }}
                                className={ccappCls(CCAPP.input, CCAPP.inputTextfield, CCAPP.fieldEditSummaryText)}
                            />
                        </Box>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
                    <Button
                        onClick={handleCloseRowPopUp}
                        variant="outlined"
                        className={ccappCls(CCAPP.input, CCAPP.inputButton, CCAPP.btnEditSummaryCancel)}
                        sx={{ borderRadius: '12px', textTransform: 'none', fontWeight: 600 }}
                    >
                        {t('general.cancel') as string}
                    </Button>
                    <Button
                        onClick={() => {
                            handleCloseRowPopUp();
                            UpdateReview(selectedReview.review.optionId, text, selectedReview.review.isApproved, null);
                        }}
                        autoFocus
                        variant="contained"
                        className={ccappCls(CCAPP.input, CCAPP.inputButton, CCAPP.btnEditSummarySave)}
                        sx={{ borderRadius: '12px', textTransform: 'none', fontWeight: 600 }}
                    >
                        {t('general.save') as string}
                    </Button>
                </DialogActions>
            </Dialog>

            {loading && <SCUILoading />}
            {datas.length > 0 ? (
                <Box>
                    {datas.map((row: any, idx: number) => (
                        <Row key={idx} review={row} />
                    ))}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }} className={CCAPP.tablePagination}>
                        <SCUIPagination
                            rowsPerPageOptions={[10, 20, 50]}
                            count={recordCount}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onRowsPerPageChange={handleChangeRows}
                            setPage={setPage}
                        />
                    </Box>
                </Box>
            ) : (
                datas.length === 0 && !loading && <NoResultFoundComponent errorText={'Sonuç bulunamadı.'} />
            )}
        </Box>
    );
};
